import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { getCurrentUser } from "../../../utils/account/common";

declare global {
  interface Window {
    SENTRY_RELEASE: string;
  }
}

const SentrySetup = () => {
  // Expose release version
  useEffect(() => {
    window.SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE ?? "";
  });

  // Set user id for easier tracing
  useEffect(() => {
    if (!Sentry.isInitialized()) {
      return;
    }
    const username = getCurrentUser()?.getUsername();

    Sentry.setUser(username ? { id: username } : null);
  }, []);

  return null;
};

export default SentrySetup;
